export enum NotificationType {
    Order = 1,
    Bill,
    Complaint,
    Enquiry,
    Disturbance,
    Reminder,
    Ticket,
    Others
}